import React from 'react';
import { Navigate } from 'react-router-dom';

// Guards /student/* routes: requires a token AND a student-role user in session.
const ProtectedRoute = ({ children }) => {
  const accessToken = localStorage.getItem('accessToken');
  let user = null;
  try {
    user = JSON.parse(sessionStorage.getItem('user'));
  } catch {
    user = null;
  }

  if (!accessToken || !user || user.role !== 'student') {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
